import { action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../../adl-gen/common';
import { DbKey } from '../../../../adl-gen/common/db';
import { AppClient, UserGroup } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { UserGroupListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { GroupData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { PageLayoutFn } from '../../../../ui/common/page-layout/page-layout';
import { ListView } from '../../common/list/list-view';
import { UserGroupListView } from '../../components/lists/usergroup-list/usergroup-list-view';

interface UserGroupScreenProps {
  pageLayout: PageLayoutFn;
  navigateTo(route: Route): void;
  groups: MaybeLoading<Paginated<UserGroupListEntry>>;
  groupData: MaybeLoading<GroupData>;
}

@observer
export class UserGroupScreen extends React.Component<UserGroupScreenProps> {
  @action
  onCancel = () => {};

  onSelectGroup = (appClientId: DbKey<AppClient>) => async (userGroupId: DbKey<UserGroup>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'group',
      appClientId: appClientId,
      id: userGroupId
    });
  };

  onCreateGroup = (appClientId: DbKey<AppClient>) => () => {
    this.props.navigateTo({
      route: 'admin',
      page: 'group',
      appClientId: appClientId,
      view: 'new'
    });
  };

  renderGroupList = observer((groups: Paginated<UserGroupListEntry>) => {
    const { groupData } = this.props;

    if (groupData.kind === 'value') {
      return (
        <ListView
          list={groups}
          fields={UserGroupListView}
          refData={groupData.value}
          onSelect={this.onSelectGroup(groupData.value.appClient.id)}
          onCreate={this.onCreateGroup(groupData.value.appClient.id)}
        />
      );
    } else {
      return null;
    }
  });

  GroupsLoader = () => <Loader state={this.props.groups} LoadedComponent={this.renderGroupList} />;

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      <this.props.pageLayout title={'Administration'}>
        <this.GroupsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/usergroup-screen/usergroup-screen.tsx